import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { SupportShift } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function deleteSupportShift(shift: SupportShift) {
  await api.delete(`/support/shifts/${shift.id}`).then(axiosSuccess).catch(axiosError);
}

export function useDeleteSupportShift() {
  const queryClient = useQueryClient();

  return useMutation((shift: SupportShift) => deleteSupportShift(shift), {
    onSuccess: () => {
      handleRequestSuccess('Agente removido do plantão.');
      queryClient.invalidateQueries('support-shifts');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao remover agente do plantão. Tente novamente.');
    },
  });
}
